// @ts-check
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';
import {
  ConnectedState,
  NotConnectedState,
  InactiveState,
  PendingValidationState,
  FailureValidationState,
  UpgrateOAuth2State
} from '../../../../authStateBar/connectedAuthStates';
import {
  AUTH_STATE_STATUSES,
  mapAuthStatusToStyleProps
} from '../../../../authStateBar/authStateBar.common';
import { LBButton } from '@linearb/buzz';
import useAuthState from './useAuthState';

const AuthStateWrapper = styled(Flex)`
  background-color: ${({ bgColor }) => `${getColor(bgColor)}`};
  border: 1px solid ${({ borderColor }) => getColor(borderColor)};
`;

const Logo = styled.img`
  height: 2rem;
  padding-left: 0.5rem;
`;

const AuthState = ({
  sensor,
  icon = null,
  name,
  onConnect,
  onReauth,
  isOrgSettings
}) => {
  const authState = useAuthState({ sensor });
  const styleConfig = mapAuthStatusToStyleProps[authState];

  return (
    <AuthStateWrapper
      items='center'
      grow='1'
      padding='small'
      mb='medium'
      minHeight='3.4rem'
      justify='space-between'
      bgColor={styleConfig.backgroundColor}
      borderColor={styleConfig.border}
    >
      <Flex items='center' grow='1'>
        {icon ? (
          <Flex pr='small'>
            <Logo src={icon} alt='' />
          </Flex>
        ) : null}
        <Text size='x-large'>{name}</Text>
        {authState === AUTH_STATE_STATUSES.NOT_CONNECTED && (
          <NotConnectedState />
        )}
        {authState === AUTH_STATE_STATUSES.CONNECTED && <ConnectedState />}
        {authState === AUTH_STATE_STATUSES.INACTIVE && isOrgSettings && (
          <InactiveState sensorName={name} onReauth={onReauth} />
        )}
        {authState === AUTH_STATE_STATUSES.PENDING_VALIDATION &&
          isOrgSettings && (
            <PendingValidationState sensorName={name} sensor={sensor} />
          )}
        {authState === AUTH_STATE_STATUSES.FAILURE_VALIDATION &&
          isOrgSettings && (
            <FailureValidationState sensorName={name} onReauth={onReauth} />
          )}
        {authState === AUTH_STATE_STATUSES.UPGRADE_TO_OAUTH2 && (
          <UpgrateOAuth2State sensorName={name} onReauth={onReauth} />
        )}
      </Flex>
      {!!onConnect && (
        <LBButton variant='outline' onClick={onConnect}>
          Connect
        </LBButton>
      )}
    </AuthStateWrapper>
  );
};

export default AuthState;
